export default __webpack_public_path__ + "static/media/Remolquede SúperLujo10.d20fd527.png";